import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

import {
	PostFavoriteDoctor,
  PostFavoriteDoctorRequest,
  PostFavoriteDoctorResponse,
} from 'domain/usecases';

export class RemotePostFavoriteDoctor implements PostFavoriteDoctor {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostFavoriteDoctorResponse>,
	) {}

	async post(params: PostFavoriteDoctorRequest): Promise<PostFavoriteDoctorResponse> {
		const {signal, ...otherParams} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: otherParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
